import { NameCell } from '@openx/components-core/lib/NameCell/NameCell.tsx';
import type { JSX } from 'react';
import { RowDescription } from '../../../../components/RowDescription/RowDescription.tsx';
import { Tags } from '../../../../components/Tags/Tags.tsx';
import { StyledTagsSection } from '../styled/StyledComponents.tsx';

export const NameCellContainer = (
  { tags, id, name, description },
  phrase: string,
  onSearchChange: (filters: { phrase: string }) => void
): JSX.Element | null => (
  <NameCell name={name} pathTo={`/details/${id}`} searchPhrase={phrase}>
    {description && <RowDescription description={description} phrase={phrase} />}
    {tags.length > 0 && (
      <StyledTagsSection>
        <Tags tags={tags} id={id} handleTagClick={onSearchChange} phrase={phrase} />
      </StyledTagsSection>
    )}
  </NameCell>
);
